(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oxymed-poc"] && !Shopify.designMode) return;
  try {
    
(function () {
  // FAQ: one open at a time
  var accs = document.querySelectorAll('.oxy-faq .oxy-acc');
  accs.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) accs.forEach(function (o) { if (o !== d) o.open = false; });
    });
  });

  // Product grid: in-browser filter + sort (needed on Page templates)
  var grid = document.querySelector('[data-oxy-grid]');
  if (!grid) return;
  var chips = [].slice.call(document.querySelectorAll('[data-oxy-filters] .oxy-chip'));
  var sortSel = document.querySelector('[data-oxy-sort]');
  var cards = [].slice.call(grid.querySelectorAll('.oxy-card'));
  var filter = 'All';

  function apply() {
    cards.forEach(function (c) {
      var tags = c.getAttribute('data-tags') || '';
      var show = (filter === 'All') || (tags.indexOf(filter.toLowerCase()) > -1);
      c.classList.toggle('oxy-card--hide', !show);
    });
    var sort = sortSel ? sortSel.value : 'featured';
    if (sort === 'low' || sort === 'high') {
      cards.slice().sort(function (a, b) {
        var pa = +a.getAttribute('data-price'), pb = +b.getAttribute('data-price');
        return sort === 'low' ? pa - pb : pb - pa;
      }).forEach(function (c) { grid.appendChild(c); });
    }
  }
  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      chips.forEach(function (o) { o.classList.remove('oxy-chip--on'); });
      c.classList.add('oxy-chip--on');
      filter = c.getAttribute('data-filter') || 'All';
      apply();
    });
  });
  if (sortSel) sortSel.addEventListener('change', apply);
})();

  } catch(e) { console.error(e); }
})();
})();
